import { FC, useState } from 'react';
import { CircleAlert } from 'lucide-react';
import { AvailableSlotsList } from '../AvailableSlotsList';
import { CalendarAvailableDatesPicker } from './CalendarAvailableDatesPicker';
import { BOOKING_BUFFER_HOURS } from '../../lib/constants';

interface CalendarWithSlotsProps {
  courseId: number;
  onBookedSlot: () => void;
  selectedSlotId?: number | null;
  onSlotSelect?: (slotId: number | null) => void;
}

export const CalendarWithSlots: FC<CalendarWithSlotsProps> = ({
  courseId,
  selectedSlotId,
  onSlotSelect,
}) => {
  const now = new Date();
  const FIRST_DAY_OF_MONTH = 1;
  const [selectedMonth, setSelectedMonth] = useState<Date>(
    new Date(now.getFullYear(), now.getMonth(), FIRST_DAY_OF_MONTH)
  );
  const [selectedDay, setSelectedDay] = useState<Date>(now);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-3 rounded-lg bg-(--warning-W100) p-2 lg:px-4 lg:py-3">
        <CircleAlert className="text-(--warning-W700) shrink-0" size={18} />
        <span className="[font-family:var(--font-montserrat)]! text-(--warning-W700) [font-size:var(--fs-l5)]! lg:[font-size:var(--fs-l4)]! font-semibold leading-tight">
          Meetings cannot be scheduled within {BOOKING_BUFFER_HOURS} hours from now. Please select a
          date further in advance.
        </span>
      </div>
      <div className="flex flex-col lg:flex-row lg:justify-between gap-2 lg:gap-8">
        <CalendarAvailableDatesPicker
          selectedMonth={selectedMonth}
          selectedDay={selectedDay}
          setSelectedMonth={setSelectedMonth}
          setSelectedDay={setSelectedDay}
          courseId={courseId}
        />
        <div className="w-[0.5px] bg-(--neutral-black-NB200) h-100%" />
        <AvailableSlotsList
          selectedDay={selectedDay}
          courseId={courseId}
          selectedSlotId={selectedSlotId}
          onSlotSelect={onSlotSelect}
        />
      </div>
    </div>
  );
};
